import React from 'react';
import { useTranslation } from 'react-i18next';
import './VideoThreadSliceInput.scss';
import ToggleButton from '../../ProducerComponents/ProducerControlPanel/Widgets/ToggleButton';
import useProject from '../../../hooks/useProject';

const VideoThreadSliceInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();

  const onChange = (value: string | number | boolean) => {
    if (project.stream.sourceLanguageIsoCode === project.encoder.languageIsoCode) {
      updateStream({
        transcoderVideoThreadSlice: value,
      });
    } else {
      updateEncoder(project.encoder, {
        transcoderVideoThreadSlice: value,
      });
    }
  };

  return (
    <div className="video-thread-slice-input">
      <div className="input-title">{t('producer.inputs.video-thread-slice.title')}</div>
      <ToggleButton
        leftText={t('producer.common.on')}
        leftValue={true}
        leftButtonClassName={`signing-settings-logo-button ${
          project.encoder?.transcoderVideoThreadSlice === true
            ? 'control-panel-button-selected-button'
            : null
        }`}
        leftContentClassName="signing-settings-logo-button-text"
        rightText={t('producer.common.off')}
        rightValue={false}
        rightButtonClassName={`signing-settings-logo-button ${
          project.encoder?.transcoderVideoThreadSlice === false
            ? 'control-panel-button-selected-button'
            : null
        }`}
        rightContentClassName="signing-settings-logo-button-text"
        footerText={t('producer.inputs.video-thread-slice.footer')}
        isReadOnly={false}
        onSelection={onChange}
        leftAccessibilityName={t('producer.common.on')}
        rightAccessibilityName={t('producer.common.off')}
      />
    </div>
  );
};

export default React.memo(VideoThreadSliceInput);
